import ReactDOM from 'react-dom/client';
import EntryPoint from './EntryPoint';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(<EntryPoint />);
